<template>
  <div class="page-stack">
    <section class="info-banner">
      <i class="el-icon-info"></i>
      <div>
        <strong>策略变更将在后续批次开放</strong>
        <p>当前页面先提供真实配置查询。上游不能覆盖 strategyId、品牌或供应商。</p>
      </div>
    </section>

    <section class="surface-card">
      <div class="section-head">
        <div>
          <p class="eyebrow">VOICE ROUTING</p>
          <h3>语音策略</h3>
        </div>
        <el-button type="primary" disabled icon="el-icon-plus">新增策略</el-button>
      </div>
      <el-table v-loading="loading" :data="items" class="clean-table">
        <el-table-column label="场景" min-width="210">
          <template slot-scope="{ row }">
            <strong>{{ row.scene }}</strong>
            <small class="table-subline">{{ row.environment }}</small>
          </template>
        </el-table-column>
        <el-table-column prop="providerCode" label="供应商" min-width="170" />
        <el-table-column prop="providerStrategyId" label="Strategy ID" width="130" />
        <el-table-column prop="brand" label="品牌" min-width="150" />
        <el-table-column label="回调 TTL" width="120">
          <template slot-scope="{ row }">{{ row.callbackTtlMinutes }} 分钟</template>
        </el-table-column>
        <el-table-column label="频控冷却" width="130">
          <template slot-scope="{ row }">{{ row.cooldownMinutes }} 分钟</template>
        </el-table-column>
        <el-table-column label="跨通道" width="110">
          <template slot-scope="{ row }">
            <span class="locked-value"><i class="el-icon-lock"></i>{{ row.crossChannelEnabled ? '开启' : '关闭' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="{ row }">
            <span :class="['simple-state', row.enabled ? 'on' : 'off']">{{ row.enabled ? '启用' : '停用' }}</span>
          </template>
        </el-table-column>
      </el-table>
    </section>
  </div>
</template>

<script>
import { getVoiceStrategies } from '../api/admin'

export default {
  name: 'VoiceStrategyView',
  data () {
    return { loading: true, items: [] }
  },
  async created () {
    try {
      this.items = await getVoiceStrategies()
    } catch (error) {
      this.$message.error('语音策略加载失败')
    } finally {
      this.loading = false
    }
  }
}
</script>

